module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/header-feed-84f3f9102ef2baabe5e67206904ab631.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/header-feed.svg
// module id = Pvj/
// module chunks = 24